import React, { useState, useRef, useEffect } from "react";
import Pagination from "../../../utils/pagination/Pagination";
import ProgressBar from "../../../utils/progressBar/ProgressBar";
import "../invoice/Invoice.css";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Checkbox,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Spinner,
  ModalCloseButton,
} from "@chakra-ui/react";
import EllipsisMenu from "../../../utils/EllipsisDropdown/EllipsisMenu";
import { useNavigate } from "react-router-dom";
import PaymentReceiveForm from "./PaymentReceiveForm";
import { Plus, Trash } from "lucide-react";
import { getPaymentReceive } from "../../../redux/reduxApi/PaymentReceiveReduxApi";
import { useSelector, useDispatch } from "react-redux";
import { deletePaymet } from "../../../redux/api/paymentReceiveApi/PaymentRecevieApi";
import { toast } from "react-toastify";
import { deletePaymentReceiveAction } from "../../../redux/reduxSlice/PaymentReceiveSlice";

function PaymentReceive() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [paymentReceiveId, setPaymentReceiveId] = useState("");
  const [paymentReceiveROWId, setPaymentReceiveROWId] = useState("");
  const [dataToEdit, setDataToEdit] = useState(null);
  const [deletePaymentId, setDeletePaymentId] = useState("");
  const [loading, setLoading] = useState(false);
   const permissions = localStorage.getItem("permissions");
  const filterData = JSON.parse(permissions);
  
  const getPaymentData = useSelector((state) => state.purchaseReceive.purchaseReceive);
  const clientList = useSelector((state) => state.utils.clientList);
  const userList = useSelector((state) => state.utils.userList);
  
  const dispatch = useDispatch();
  const desktopRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const page = 1;
    setLoading(true);
    dispatch(getPaymentReceive(page))
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, [dispatch]);

  const handleDelete = () => {
    const idsToDelete = selectedRows.length > 0 ? selectedRows : [deletePaymentId];
    setLoading(true);
    Promise.all(idsToDelete.map((id) => deletePaymet(id)))
      .then(() => {
        // Update Redux state
        dispatch(deletePaymentReceiveAction(idsToDelete));
        toast.success("Payment(s) deleted successfully");
      })
      .catch((error) => {
        console.error(error);
        toast.error("Failed to delete payment(s)");
      })
      .finally(() => {
        setLoading(false);
        closeTrash();
        setSelectedRows([]);
        setDeletePaymentId("");
      });
  };

  const closeTrash = () => {
    setIsOpen(false);
    setDeletePaymentId("");
  };

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setIsUpdateMode(false);
    setDataToEdit(null);
  };

  const handleSelectAllRows = (e) => {
    if (e.target.checked) {
      setSelectedRows(getPaymentData.map((item) => item.ROWID));
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (rowId) => {
    setSelectedRows((prev) =>
      prev.includes(rowId)
        ? prev.filter((id) => id !== rowId)
        : [...prev, rowId]
    );
  };

  const handleNewData = (newData) => {
    // This will be handled by Redux automatically
  };

  const getClientName = (id) => {
    const client = clientList.find((item) => item?.clients?.ROWID === id);
    if (client) {
      return `${client.clients.salutation || ""} ${client.clients.firstName || ""} ${client.clients.lastName || ""}`.trim();
    }
    return "Unknown Client";
  };

  const ownerName = (id) => {
    const employeeData = userList.find((item) => item?.employees?.ROWID === id);
    return employeeData?.employees?.employeeName || "Unknown";
  };

  return (
    <>
      {loading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="pink.500" />
        </div>
      )}
      
      <Modal isOpen={isOpen} onClose={closeTrash}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Are you sure you want to Delete?</ModalHeader>
          <ModalCloseButton />
          <ModalBody></ModalBody>
          <ModalFooter>
            <Button className="create-button" mr={3} onClick={handleDelete}>
              Delete
            </Button>
            <Button className="cancel-button" onClick={closeTrash}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      
      <div>
        <div ref={desktopRef}>
          <div className="d-flex justify-content-end">
            {selectedRows.length === 0 && (
              <button className="new-button mx-2" onClick={openDrawer}>
                <Plus size="18px" />
                <span className="ms-1">New</span>
              </button>
            )}

            {selectedRows.length > 0 && (
              <button 
                className="new-button mx-2" 
                onClick={() => setIsOpen(true)}
              >
                <Trash size="18px" />
                <span className="ms-1">Delete Selected</span>
              </button>
            )}
          </div>
        </div>
        
        <div
          className="custom-scroll"
          style={{ minHeight: "75vh", overflow: "scroll" }}
        >
          <TableContainer
            className="card card-detail mt-1 scrollable-container"
            style={{
              minHeight: "75vh",
              backgroundColor: "white",
              border: "none",
              position: "relative",
              overflowY: "scroll",
              scrollbarColor: "#A0AEC0 #EDF2F7",
              scrollbarWidth: "10px",
            }}
          >
            <Table variant="simple" size="sm">
              <Thead>
                <Tr className="tr-border">
                  <Th className="py-1 th-color">
                    <Checkbox
                      isChecked={selectedRows.length === getPaymentData.length}
                      onChange={handleSelectAllRows}
                    />
                  </Th>
                  <Th className="py-1 th-color">Actions</Th>
                  <Th className="py-1 th-color">Customer Name</Th>
                  <Th className="py-1 th-color">Sales Person</Th>
                  <Th className="py-1 th-color">Payment Date</Th>
                  <Th className="py-1 th-color">Reference#</Th>
                  <Th className="py-1 th-color">Payment#</Th>
                  <Th className="py-1 th-color">Payment Mode</Th>
                  <Th className="py-1 th-color">Deposit To</Th>
                </Tr>
              </Thead>
              <Tbody>
                {Array.isArray(getPaymentData) && getPaymentData.length > 0 ? (
                  getPaymentData.map((item) => (
                    <Tr
                      key={item.ROWID}
                      className="tr-border"
                      style={{ cursor: "pointer", position: "relative" }}
                    >
                      <Td>
                        <Checkbox
                          isChecked={selectedRows.includes(item.ROWID)}
                          onChange={() => handleRowSelect(item.ROWID)}
                        />
                      </Td>
                      <Td style={{ width: "110px", textAlign: "center" }}>
                        <EllipsisMenu
                          item={item}
                          onView={() => navigate(`/payment-receive-detail/${item.ROWID}`)}
                          onEdit={() => {
                            setDataToEdit(item);
                            setIsUpdateMode(true);
                            setPaymentReceiveId(item.ROWID);
                            openDrawer();
                          }}
                          onDelete={() => {
                            setDeletePaymentId(item.ROWID);
                            setIsOpen(true);
                          }}
                           permissions={{
                            canEdit: filterData?.find((mod) => mod.moduleName === "Payment Receive" && mod.modifyAll === true),
                            canDelete: filterData?.find((mod) => mod.moduleName === "Payment Receive" && mod.delete === true),
                            canView: true, // Usually always true, but you can make this dynamic too
                          }}
                        />
                      </Td>
                      <Td className="font-colors">{getClientName(item?.customerName)}</Td>
                      <Td className="font-colors">{ownerName(item.salesPerson)}</Td>
                      <Td className="font-colors">{item?.paymentDate}</Td>
                      <Td className="font-colors">{item.reference}</Td>
                      <Td className="font-colors">{item.payment}</Td>
                      <Td className="font-colors">{item.paymentMode}</Td>
                      <Td className="font-colors">{item.despiteTo}</Td>
                    </Tr>
                  ))
                ) : (
                  <Tr>
                    <Td colSpan={9} className="text-center">
                      No payments found.
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
        
        <div className="footer">
          <div className="footer d-flex fixed-bottom start-20">
            <div
              className="total"
              style={{ marginLeft: "16%", marginTop: "15px" }}
            >
              <p className="fw-semibold">
                Total Count: {getPaymentData?.length || 0}
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-center position-fixed-bottom mx-auto">
              <Pagination
                totalPages={Math.ceil((getPaymentData?.length || 0) / 30)}
                onPageChange={setCurrentPage}
              />
            </div>
            <PaymentReceiveForm
              closeDrawer={closeDrawer}
              isDrawerOpen={isDrawerOpen}
              isUpdateMode={isUpdateMode}
              paymentReceiveId={paymentReceiveId}
              paymentReceiveROWId={paymentReceiveROWId}
              setIsUpdateMode={setIsUpdateMode}
              dataToEdit={dataToEdit}
              onNewDataAdded={handleNewData}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default PaymentReceive;
